interface ElementTagProps {
  element: string;
  size?: 'sm' | 'md';
}

const elementMap: Record<
  string,
  { icon: string; text: string; bg: string; dot: string }
> = {
  火: { icon: 'ri-fire-line', text: 'text-orange-700', bg: 'bg-orange-100', dot: 'bg-orange-500' },
  水: { icon: 'ri-drop-line', text: 'text-sky-700', bg: 'bg-sky-100', dot: 'bg-sky-500' },
  冰: { icon: 'ri-snowflake-line', text: 'text-cyan-700', bg: 'bg-cyan-100', dot: 'bg-cyan-500' },
  风: { icon: 'ri-windy-line', text: 'text-teal-700', bg: 'bg-teal-100', dot: 'bg-teal-500' },
  雷: { icon: 'ri-flashlight-line', text: 'text-amber-700', bg: 'bg-amber-100', dot: 'bg-amber-500' },
  草: { icon: 'ri-leaf-line', text: 'text-green-700', bg: 'bg-green-100', dot: 'bg-green-500' },
  岩: { icon: 'ri-shield-line', text: 'text-yellow-700', bg: 'bg-yellow-100', dot: 'bg-yellow-600' },
};

export default function ElementTag({ element, size = 'sm' }: ElementTagProps) {
  const conf = elementMap[element] ?? {
    icon: 'ri-sparkling-line',
    text: 'text-foreground-700',
    bg: 'bg-background-200',
    dot: 'bg-foreground-500',
  };
  const pad = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${conf.text} ${conf.bg} ${pad}`}
    >
      <i className={`${conf.icon} text-[1em]`}></i>
      {element}元素
    </span>
  );
}

export function elementDot(element: string) {
  const conf = elementMap[element];
  return conf ? conf.dot : 'bg-foreground-400';
}

export function elementColorText(element: string) {
  const conf = elementMap[element];
  return conf ? conf.text : 'text-foreground-700';
}